<template>
  <div :class=textColor>
    <template v-if="status === 0">
      <b-spinner label="読込中..."></b-spinner>
    </template>
    <div v-if="status !== 200">
      <p>{{ errorMessage }}</p>
    </div>
    <div v-if="status === 200 && customMessage">
      {{customMessage}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    status: Number,
    customMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    errorMessage: function () {
      if (this.customMessage) {
        return this.customMessage
      }
      return this.$constList.apiErrorTypes[this.status]
    },
    textColor () {
      if (this.status === 0 || this.status === 200) {
        return 'text-black-50'
      }
      return 'text-danger'
    }
  }
}
</script>
